export default "__VITE_ASSET__DT1C7rGo__"